export const messages = {
  en: {
    personalCenter: {
      title: 'Personal Center',
      orderManagement: 'Order Management',
      shippingAddress: 'Shipping Address',
      personalInfo: 'Personal Information',
      orderList: 'Order List',
      productInfo: 'Product Info',
      unitPrice: 'Unit Price',
      quantity: 'Quantity',
      actualPayment: 'Actual Payment',
      operations: 'Operations',
      orderTime: 'Order Time',
      orderNumber: 'Order Number',
      totalPrice: 'Total Price',
      consignee: 'Consignee',
      shippingAddressPhone: 'Shipping Address & Phone',
      closeOrder: 'Close Order',
      expediteDelivery: 'Expedite Delivery',
      logisticsInfo: 'Logistics Info',
      confirmReceipt: 'Confirm Receipt',
      evaluateNow: 'Evaluate Now',
      returnGoods: 'Return Goods',
      refundApplication: 'Refund Application',
      orderClosed: 'Order Closed',
      orderCompleted: 'Order Completed',
      pendingShipment: 'Pending Shipment'
    }
  },
  zh: {
    personalCenter: {
      title: '个人中心',
      orderManagement: '订单管理',
      shippingAddress: '收货地址',
      personalInfo: '个人信息',
      orderList: '订单列表',
      productInfo: '商品信息',
      unitPrice: '单价',
      quantity: '数量',
      actualPayment: '实付款',
      operations: '操作',
      orderTime: '订单时间',
      orderNumber: '订单编号',
      totalPrice: '订单总价',
      consignee: '收货人姓名',
      shippingAddressPhone: '收货地址电话',
      closeOrder: '关闭订单',
      expediteDelivery: '催发货',
      logisticsInfo: '物流信息',
      confirmReceipt: '确认收货',
      evaluateNow: '立即评价',
      returnGoods: '退货',
      refundApplication: '申请退款',
      orderClosed: '订单已关闭',
      orderCompleted: '已完成',
      pendingShipment: '待发货'
    }
  }
}